import { TransferAgentStatus } from "../types/transfer.types";
import { colors, alphaVar } from "../../../../../ui/colors";

export const STATUS_CONFIG: Record<
    TransferAgentStatus,
    { label: string; color: string; bg: string }
> = {
    available: {
        label: "Available",
        color: colors.orange[700],
        bg: alphaVar(colors.orange.base, 0.12),
    },
    busy: {
        label: "Busy",
        color: colors.blue?.[700] ?? "#1d4ed8",
        bg: alphaVar(colors.blue?.[500] ?? "#2563eb", 0.1),
    },
    disconnected: {
        label: "Disconnected",
        color: colors.gray[400],
        bg: alphaVar(colors.gray[300], 0.14),
    },
};